import { Modal, notification } from "antd"
import { usePermissionData } from "AppContext"
import { axiosbaseurl } from "../config"
import { useEffect, useMemo, useState } from "react"
import React from "react"
import Loader from "./Loader"
import PermittedComponent from "PermittedComponent"
import { FaChevronLeft, FaChevronRight, FaEye } from "react-icons/fa"
import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import moment from "moment"
import { IoMdWarning } from "react-icons/io"
import { SiTicktick } from "react-icons/si"
import { RiArrowUpDownFill } from "react-icons/ri"

const CustomerQuery = () => {
  document.title = "Customer Query | Return First Investments"

  const { checkAccess } = usePermissionData()

  const [Loading, setLoading] = useState(false)
  const [Data, setData] = useState([])
  const [Users, setUsers] = useState([])
  const [CurrentItem, setCurrentItem] = useState({})

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`query`)
      if (response?.data?.success) {
        setUsers(response?.data?.data?.reverse())
        setData(response?.data?.data)
      }
    } catch (e) {
      console.log("Error", e)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = Users.filter(
      session =>
        session.customerName
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session.email
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session?.contactNumber
          ?.toLowerCase()
          .includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(Data?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const [Modal1, setModal] = useState(false)

  const handleModal = item => {
    setCurrentItem(item)
    setModal(true)
  }

  const handleStatusChange = async (ticketid, status) => {
    try {
      setLoading(true)
      const response = await axiosbaseurl.patch(`query/${ticketid}`, {
        status: status,
      })

      if (response?.data?.success === true) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex align-items-center">
              <div className="pr-20">
                <SiTicktick className="text-success fs-4 me-2" />
              </div>
              <div className="succes-message">
                Query status updated Successfully.
              </div>
            </div>
          ),
          placement: "topRight",
        })
        setModal(false)
        getData()
      } else {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
        })
      }
    } catch (e) {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Opps! Something went wrong.</div>
          </div>
        ),
        description: e?.response?.data?.message,
      })
    }
  }

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  // Memoize sorted data
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return Data

    const sortableItems = [...Data]

    sortableItems.sort((a, b) => {
      let aValue, bValue

      // Adjust based on key you want to sort on
      // For example, if sorting by customerName (nested in customer)
      if (sortConfig.key === "customerName") {
        aValue = a?.customer?.customerName?.toLowerCase() || ""
        bValue = b?.customer?.customerName?.toLowerCase() || ""
      } else if (sortConfig.key === "email") {
        aValue = a?.customer?.email?.toLowerCase() || ""
        bValue = b?.customer?.email?.toLowerCase() || ""
      } else if (sortConfig.key === "contactNumber") {
        aValue = a?.customer?.contactNumber?.toLowerCase() || ""
        bValue = b?.customer?.contactNumber?.toLowerCase() || ""
      } else if (sortConfig.key === "status") {
        aValue = a.status ? 1 : 0
        bValue = b.status ? 1 : 0
      } else {
        // fallback to direct property
        aValue = a[sortConfig.key]
        bValue = b[sortConfig.key]
      }

      if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1
      if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1
      return 0
    })

    return sortableItems
  }, [Data, sortConfig])

  // Use sortedData for pagination instead of raw Data
  const final_data = sortedData.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  // Function to request sorting on a key (toggle direction)
  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(12, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"Customer Query"} />

            <div className="card p-2 py-3">
              <div className="d-flex align-items-center">
                <div className="search-box position-relative">
                  <input
                    className="form-control form-control1 ps-6"
                    placeholder="Search Enquiry"
                    onChange={filterByName}
                  />
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
                <select
                  className="form-select form-select1 ms-3 fs-6 rounded-5"
                  value={items_perpage}
                  onChange={e => setItemsPerPage(e.target.value)}
                  style={{ width: "110px" }}
                >
                  <option value="5">Show 5</option>
                  <option value="10">Show 10</option>
                  <option value="20">Show 20</option>
                  <option value="30">Show 30</option>
                </select>
              </div>
              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("customerName")}
                      >
                        Sender Name{" "}
                        {sortConfig.key === "customerName" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("email")}
                      >
                        Email Address{" "}
                        {sortConfig.key === "email" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("contactNumber")}
                      >
                        Phone Number{" "}
                        {sortConfig.key === "contactNumber" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("status")}
                      >
                        Status{" "}
                        {sortConfig.key === "status" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>
                      <th>View</th>
                    </tr>
                  </thead>

                  <tbody>
                    {final_data?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td>{item?.customerName	}</td>
                        <td>{item?.email}</td>
                        <td>{item?.contactNumber}</td>
                        <td>
                          {item?.status === true ? "Resolved" : "Pending"}
                        </td>
                        <td>
                          <button
                            className="btn Edit-Button"
                            onClick={() => handleModal(item)}
                          >
                            <FaEye /> View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="text-center">
                {final_data?.length < 1
                  ? "No customer query available at this moment !"
                  : ""}
              </div>
              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-7">
                  Showing {final_data?.length} out of {Data?.length} enquiries.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <Modal
          open={Modal1}
          onCancel={() => setModal(false)}
          footer={false}
          title="Enquiry Description"
          width={700}
          bodyStyle={{ padding: "0" }}
          centered
        >
          <div className="bg-gradientt p-4">
            <table
              className="table Cutom-popup-table"
              style={{ verticalAlign: "middle" }}
            >
              <tbody>
                <tr>
                  <th className="col-4 text-green p-3 py-2">Ticket ID</th>
                  <td className="p-3">{CurrentItem?.ticketId}</td>
                </tr>
                <tr>
                  <th className="col-4 text-green p-3 py-2">Customer Name</th>
                  <td className="p-3">{CurrentItem?.customerName}</td>
                </tr>
                <tr>
                  <th className="col-4 text-green p-3 py-2">Query</th>
                  <td className="p-3">{CurrentItem?.query}</td>
                </tr>
                <tr>
                  <th className="col-4 text-green p-3 py-2">Status</th>
                  <td className="p-3">
                    <select
                      value={CurrentItem?.status}
                      className="form-select text-white bg-transparent fs-5"
                      disabled={CurrentItem?.status === true}
                      onChange={e =>
                        handleStatusChange(CurrentItem?.id, e.target.value)
                      }
                    >
                      <option className="text-dark fs-6" value={false}>
                        Pending
                      </option>
                      <option className="text-dark fs-6" value={true}>
                        Resolved
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th className="col-4 text-green p-3 py-2">Received At</th>
                  <td className="p-3">
                    {moment(CurrentItem?.created_at).format(
                      "DD MMMM YYYY | HH:mm A"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default CustomerQuery
